<app-common-dialog-wrapper
  [headerText]="headerText"
  (onDialogClose)="onDialogClose($event)"
  >
  <section class="data-section">
    <mds-search-bar
      [placeholder]="placeholder"
      [formControl]="searchText"
      theme="light"
      [hideEnterButton]="true"
    ></mds-search-bar>

    <section class="data-section__results">
      @for (s of searchResults; track s) {
        <div>
          @for (data of s.cards; track data) {
            <div
              class="product-container"
              (click)="updateTilesSelection(data)"
              >
              <mds-checkbox
                [value]="selectedTilesRid.includes(data.rid)"
                name="select product"
                (change)="updateTilesSelection(data); $event.stopPropagation()"
                >
              </mds-checkbox>
              <mds-object-card
                [compact]="true"
                [data]="data"
              ></mds-object-card>
            </div>
          }
          @if (s.cards.length === 0) {
            <div class="no-result-found">
              No Result Found
            </div>
          }
        </div>
      }
    </section>
  </section>
  <section custom-bottom-buttons class="footer-section">
    <div class="footer-section__left-buttons">
      @if (selectedTilesRid.length != searchResultsCount) {
        <mds-button
          aria-label="select all products"
          type="secondary"
          size="medium"
          (click)="selectAll()"
          >
          {{ selectAllText }}
        </mds-button>
      }
      @if (selectedTilesRid.length > 0) {
        <mds-button
          aria-label="deselect all products"
          type="secondary"
          size="medium"
          (click)="clearSelections()"
          >
          {{ deSelectAllText }}
        </mds-button>
      }
    </div>
    <div class="footer-section__right-buttons">
      <mds-button type="secondary" size="medium" (click)="closeModal()">
        Cancel
      </mds-button>
      <mds-button
        type="primary"
        size="medium"
        [disabled]="selectedTilesRid && selectedTilesRid.length < 1"
        (click)="enrichProductSelect()"
        >
        {{ submitButtonText }}
      </mds-button>
    </div>
  </section>
</app-common-dialog-wrapper>
